export default __webpack_public_path__ + "images/e5955885ed84e5f373e4c5a9dc550b2c-icon-pros.svg";